import { LoadingSquare } from "../styles/loading";
import logo from "../assets/logos/jallesLogo.png";

export const SquareLoading = () => {
  return (
    <LoadingSquare>
      <img src={logo} alt="" />
      <span className="loaderSquare">
        <span className="loaderSquare-inner"></span>
      </span>
      <h3>Loading...</h3>
    </LoadingSquare>
  );
};
